import Layout from '@/container/Full'

const Downtime = () => import(/* webpackChunkName: "downtime" */ '@/views/downtime/DowntimeView')
const DowntimeSingle = () => import(/* webpackChunkName: "downtime" */ '@/views/downtime/DowntimeSingleView')

const routes = [
  {
    path: '/status',
    component: Layout,
    children: [
      {
        path: '',
        name: 'downtime',
        component: Downtime,
        meta: {
          access_type: 'authorized',
        },
      },
      {
        path: '/status/:id',
        name: 'downtime-single',
        component: DowntimeSingle,
        meta: {
          access_type: 'authorized',
        },
      },
    ],
  },
]

export default routes
